const KEY = "fm_nav_app";

export const NAV_APPS = [
  { id: "google", label: "Google Maps" },
  { id: "waze", label: "Waze" },
  { id: "apple", label: "Apple Kartor" },
];

export const getPreferredNav = () => localStorage.getItem(KEY) || "";
export const setPreferredNav = (id) => localStorage.setItem(KEY, id);

export const navUrl = (appId, address) => {
  const a = encodeURIComponent((address || "").trim());
  if (appId === "waze") return `https://www.waze.com/ul?q=${a}&navigate=yes`;
  if (appId === "apple") return `https://maps.apple.com/?daddr=${a}&dirflg=d`;
  return `https://www.google.com/maps/dir/?api=1&destination=${a}`;
};

// Öppnar via ett riktigt länkklick: undviker tom flik när window.open blockeras
export const openNav = (appId, address) => {
  if (!address) return false;
  setPreferredNav(appId);
  const url = navUrl(appId, address);
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return true;
};
